import React from 'react';

interface TabBarProps {
  value: string;
  onChange: (newValue: string) => void;
  children: JSX.Element[];
  textColor: string;
  indicatorColor: string;
  overflow?: string;
}

export function TabBar({
  children,
  value,
  onChange,
  textColor,
  indicatorColor,
  overflow = 'overflow-hidden'
}: TabBarProps) {
  return (
    <div className={`flex items-center gap-10 ${overflow} list-scrollbar`}>
      {children.map((i, index) =>
        React.cloneElement(i, {
          onClick: onChange,
          activeValue: value,
          textColor,
          indicatorColor,
          key: index
        })
      )}
    </div>
  );
}
